import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IDataInput, IUserSettingsAddPathResponse } from '../../../../interface/interfaces';

interface IInitialState {
    userSettingsAllFilePathLoading: boolean;
    userSettingsAllFilePathData: IUserSettingsAddPathResponse[];
    userSettingsAllFilePathError: string;
}

const initialState: IInitialState = {
    userSettingsAllFilePathLoading: false,
    userSettingsAllFilePathData: [],
    userSettingsAllFilePathError: '',
};

const userSettingsAllFilePathSlice = createSlice({
    name: 'userSettingsAllFilePath',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fetchUserSettingsAllFilePathPending: (state: IInitialState, action: PayloadAction<IDataInput>) => {
            state.userSettingsAllFilePathLoading = true;
            state.userSettingsAllFilePathData = [];
            state.userSettingsAllFilePathError = '';
        },

        fetchUserSettingsAllFilePathFulfilled: (state: IInitialState, action: PayloadAction<IUserSettingsAddPathResponse[]>) => {
            state.userSettingsAllFilePathLoading = false;
            state.userSettingsAllFilePathData = action.payload;
            state.userSettingsAllFilePathError = '';
        },

        fetchUserSettingsAllFilePathFailure: (state: IInitialState, action: PayloadAction<string>) => {
            state.userSettingsAllFilePathLoading = false;
            state.userSettingsAllFilePathData = [];
            state.userSettingsAllFilePathError = action.payload;
        },
    },
});

export default userSettingsAllFilePathSlice.reducer;
export const { fetchUserSettingsAllFilePathPending, fetchUserSettingsAllFilePathFulfilled, fetchUserSettingsAllFilePathFailure } = userSettingsAllFilePathSlice.actions;
